var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"section content is-size-7"},[_c('p',[_vm._v("\n      E-Mail: "),_c('a',{attrs:{"href":"mailto:cuca@778mobile.com"}},[_vm._v("cuca@778mobile.com")]),_vm._v(" "),_c('br')])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9eca8300","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LangKyf/KE/Help.vue
// module id = null
// module chunks = 